<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <b-card class="mb-0">
        <b-img
          center
          fluid
          :src="require('@/assets/images/logo/LOGOREUNIBOX.png')"
        />
        <br>
        <b-card-title class="mb-1">
          Espace administration DOMICIALIZ
        </b-card-title>
        <validation-observer
          ref="loginForm"
          #default="{invalid}"
        >
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent="login"
          >
            <b-form-group
              label="Email"
              label-for="admin-email"
            >
              <validation-provider
                #default="{ errors }"
                name="Email"
                vid="email"
                rules="required|email"
              >
                <b-form-input
                  id="admin-email"
                  v-model="userEmail"
                  :state="errors.length > 0 ? false : null"
                  name="admin-email"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group>
              <div class="d-flex justify-content-between">
                <label for="admin-password">Mot de passe</label>
                <b-link :to="{ name: 'admin-dom-forgot-password' }">
                  <small>Mot de passe oublié ?</small>
                </b-link>
              </div>
              <validation-provider
                #default="{ errors }"
                name="Password"
                vid="password"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="admin-password"
                    v-model="password"
                    :state="errors.length > 0 ? false : null"
                    class="form-control-merge"
                    :type="passwordFieldType"
                    name="admin-password"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-button
              type="submit"
              variant="primary"
              block
              :disabled="invalid || loading"
            >
              <b-spinner
                v-if="loading"
                small
              />
              <span v-else>Connexion</span>
            </b-button>
          </b-form>
        </validation-observer>
      </b-card>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BCard, BCardTitle, BImg, BForm, BButton, BSpinner, BLink,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BSpinner,
    BLink,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      userEmail: '',
      password: '',
      loading: false,
      required,
      email,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    authHeaders() {
      return { headers: { 'x-access-token': localStorage.getItem('domAdminToken') } }
    },
    login() {
      this.$refs.loginForm.validate().then(success => {
        if (!success) return
        this.loading = true
        this.$http.post('/admindom/login', {
          email: this.userEmail,
          password: this.password,
        })
          .then(response => {
            this.loading = false
            if (response.data.res === 1) {
              localStorage.setItem('domAdminToken', response.data.token)
              localStorage.setItem('domAdminData', JSON.stringify(response.data.admin))
              this.$router.push({ name: 'admin-dom-dossiers' })
                .then(() => {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: `Bonjour ${response.data.admin.prenom || response.data.admin.email}`,
                      icon: 'UserCheckIcon',
                      variant: 'success',
                    },
                  })
                })
            } else {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Identifiants invalides',
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                  text: response.data.message || 'Vérifiez votre email et mot de passe.',
                },
              })
            }
          })
          .catch(() => {
            this.loading = false
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Erreur',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
                text: 'Impossible de contacter le serveur.',
              },
            })
          })
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
